module.exports = __webpack_public_path__ + "static/img/toncheva.d70cf94.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/toncheva.jpg
// module id = 506
// module chunks = 11